import React from 'react';
import './switch-icon.scss';

function SwitchIcon(props) {
  const { action } = props;
  return (
    <svg
      className="switch-icon"
      id="Capa_1"
      enableBackground="new 0 0 512.101 512.101"
      height="16px"
      viewBox="0 0 512.101 512.101"
      width="16px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          className={`widgets ${action}`}
          d="m436.862 75.238c-100.3-100.301-261.29-100.335-361.624 0-100.301
					100.3-100.335 261.29 0 361.624 100.3 100.301 261.29 100.335 361.624 0 100.301-100.299
					100.335-261.29 0-361.624zm-180.812 406.812c-124.617 0-226-101.383-226-226s101.383-226
					226-226 226 101.383 226 226-101.383 226-226 226z"
        />
        <path
          className={action}
          d="m329.703 173.005c-6.197-5.499-15.677-4.934-21.176 1.263-5.499
					6.196-4.934 15.677 1.263 21.176 17.324 15.375 27.26 37.465 27.26 60.607 0 44.664-36.336
					81-81 81s-81-36.336-81-81c0-23.371 10.101-45.606 27.712-61.005 6.236-5.453 6.872-14.929
					1.418-21.166-5.453-6.237-14.929-6.871-21.166-1.418-24.127 21.096-37.965 51.563-37.965
					83.589 0 61.206 49.794 111 111 111s111-49.794 111-111c.001-31.714-13.611-61.982-37.346-83.046z"
        />
        <path
          className={action}
          d="m256.05 231.05c8.284 0 15-6.716 15-15v-80c0-8.284-6.716-15-15-15s-15
					6.716-15 15v80c0 8.285 6.716 15 15 15z"
        />
      </g>
    </svg>
  );
}

export default SwitchIcon;
